import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppService } from 'src/app/appservice.service';

@Component({
    selector: 'app-user-dialog',
    templateUrl: './user-dialog.component.html',
    styleUrls: ['./user-dialog.component.css']
})
export class UserDialogComponent implements OnInit {

    userForm: FormGroup;
    isEditing = false;
    isSubmitting = false;

    constructor(
        public dialogRef: MatDialogRef<UserDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public service: AppService
    ) {
        this.isEditing = !!data.user;

        this.userForm = new FormGroup({
            username: new FormControl('', [Validators.required]),
            password: new FormControl('', this.isEditing ? [] : [Validators.required]),
            name: new FormControl(''),
            role: new FormControl('staff', [Validators.required])
        });

        if (this.isEditing) {
            this.userForm.patchValue({
                username: data.user.username,
                name: data.user.name,
                role: data.user.role,
                password: ''
            });
        }
    }

    ngOnInit() {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        if (this.userForm.valid) {
            this.isSubmitting = true;
            const userData = this.userForm.value;

            if (this.isEditing) {
                this.service.putRequestData('api/admin/users/' + this.data.user.id, userData).subscribe(res => {
                    this.isSubmitting = false;
                    if (res.success) {
                        this.dialogRef.close(true);
                    } else {
                        this.service.sendMessage(res.message || 'Update failed');
                    }
                }, err => {
                    this.isSubmitting = false;
                    this.service.sendMessage('Oops');
                });
            } else {
                this.service.getRequestData('api/admin/users', userData).subscribe(res => {
                    this.isSubmitting = false;
                    if (res.success) {
                        this.dialogRef.close(true);
                    } else {
                        this.service.sendMessage(res.message || 'Creation failed');
                    }
                }, err => {
                    this.isSubmitting = false;
                    this.service.sendMessage('Oops');
                });
            }
        }
    }

}
